var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2BA5F7"
    },
    d: "M256.002,90.32c-4.725,0-8.553-3.829-8.553-8.553V23.369c0-4.723,3.828-8.553,8.553-8.553 c4.725,0,8.553,3.829,8.553,8.553v58.398C264.555,86.49,260.727,90.32,256.002,90.32z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.825,
    y: 208.645,
    style: {
      fill: "#E09B2D"
    },
    width: 128.351,
    height: 34.782
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M364.126,81.047v136.721h-43.951H191.825h-43.951V81.047c0-15.977,12.955-28.932,28.932-28.932h79.2 h79.189C351.182,52.116,364.126,65.071,364.126,81.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E54728"
    },
    d: "M196.192,52.116h-19.387c-15.977,0-28.932,12.955-28.932,28.932v136.721h19.387V81.047 C167.261,65.071,180.216,52.116,196.192,52.116z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 171.606,
    y: 363.784,
    style: {
      fill: "#F7B239"
    },
    width: 33.413,
    height: 121.303
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.992,
    y: 363.784,
    style: {
      fill: "#F7B239"
    },
    width: 33.402,
    height: 121.303
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M306.992,364.924v42.103h33.402v-42.103H306.992z M171.606,407.027h33.413v-42.103h-33.413V407.027z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.799,
    y: 264.091,
    style: {
      fill: "#F7B239"
    },
    width: 62.299,
    height: 35.17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.468,
    y: 264.091,
    style: {
      fill: "#F7B239"
    },
    width: 63.166,
    height: 35.17
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M203.251,108.576c16.513,0,29.89,13.388,29.89,29.89c0,16.513-13.377,29.89-29.89,29.89 c-16.501,0-29.878-13.377-29.878-29.89C173.373,121.964,186.75,108.576,203.251,108.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M308.749,108.576c16.501,0,29.89,13.388,29.89,29.89c0,16.513-13.388,29.89-29.89,29.89 c-16.513,0-29.89-13.377-29.89-29.89C278.859,121.964,292.236,108.576,308.749,108.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "224.36,471.562 224.36,512 152.265,512 152.265,471.562 171.606,471.562 205.019,471.562  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F95428"
    },
    points: "359.735,471.562 359.735,512 287.651,512 287.651,471.562 306.992,471.562 340.394,471.562  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M416.253,269.611v140.416h-31.885V299.261v-35.17v-26.366l0,0 C401.978,237.725,416.253,252.001,416.253,269.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95428"
    },
    d: "M127.632,299.261v110.766H95.747V269.611c0-17.61,14.275-31.885,31.885-31.885l0,0v26.366V299.261z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2BA5F7"
    },
    d: "M364.126,299.261v78.048h-23.731v-0.011h-33.402v0.011H205.019v-0.011h-33.413v0.011h-23.731v-78.048 v-35.17v-26.366h43.951h128.351h43.951v26.366L364.126,299.261L364.126,299.261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.874,
    y: 237.725,
    style: {
      fill: "#2197D8"
    },
    width: 38.043,
    height: 139.572
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M241.698,138.467c0-21.196-17.245-38.441-38.441-38.441c-21.198,0-38.442,17.245-38.442,38.441 s17.245,38.441,38.442,38.441C224.453,176.908,241.698,159.663,241.698,138.467z M181.92,138.467 c0-11.764,9.572-21.336,21.337-21.336s21.336,9.571,21.336,21.336c0,11.764-9.571,21.336-21.336,21.336 S181.92,150.231,181.92,138.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M308.748,176.908c21.196,0,38.441-17.245,38.441-38.441s-17.245-38.441-38.441-38.441 c-21.198,0-38.442,17.245-38.442,38.441S287.55,176.908,308.748,176.908z M308.748,117.13c11.764,0,21.335,9.571,21.335,21.336 s-9.571,21.336-21.335,21.336s-21.337-9.571-21.337-21.336S296.983,117.13,308.748,117.13z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D4D4D"
    },
    cx: 316.275,
    cy: 271.127,
    r: 8.553
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D4D4D"
    },
    cx: 195.725,
    cy: 271.127,
    r: 8.553
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B239"
    },
    cx: 256.006,
    cy: 14.816,
    r: 14.816
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M303.469,330.906h-94.937c0-11.073,3.798-21.268,10.149-29.342 c8.701-11.039,22.181-18.132,37.325-18.132C282.223,283.432,303.469,304.689,303.469,330.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M294.813,330.906h-86.282c0-11.073,3.798-21.268,10.149-29.342 c8.074-6.352,18.258-10.149,29.342-10.149C271.515,291.415,291.027,308.486,294.813,330.906z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/robot.f9ea1a163451012b76437b730806aa28.svg";
export { ForwardRef as ReactComponent };